// extracted by mini-css-extract-plugin
module.exports = {"edge":"MultiSlider_edge__zW8kX","leftEdge":"MultiSlider_leftEdge__x8GHz","rightEdge":"MultiSlider_rightEdge__1Iu-b","sliderStyle":"MultiSlider_sliderStyle__2LLX2"};